export default value => {
  if (!value) return value

  return value.match(/.{1,4}/g).join(' ')
}
